import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import LoginModal from "../auth/LoginModal";
import SignupModal from "../auth/SignupModal";
import WishlistPage from "./WishlistPage";
import TripHistoryOverlay from "./TripHistoryOverlay";

const NavBar = ({ categories = [] }) => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [showLogin, setShowLogin] = useState(false);
  const [showSignup, setShowSignup] = useState(false);
  const [showWishlist, setShowWishlist] = useState(false);
  const [currentUser, setCurrentUser] = useState(null);
  const navigate = useNavigate();

  const openLoginModal = () => setShowLogin(true);
  const closeLoginModal = () => setShowLogin(false);
  const openSignupModal = () => setShowSignup(true);
  const closeSignupModal = () => setShowSignup(false);
  const [showTripHistory, setShowTripHistory] = useState(false);

  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 100);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    const loadUser = () => {
      const storedUser = localStorage.getItem("user");
      setCurrentUser(storedUser ? JSON.parse(storedUser) : null);
    };

    loadUser(); // Load initially

    // Listen for login or logout events
    window.addEventListener("userLoggedIn", loadUser);
    return () => window.removeEventListener("userLoggedIn", loadUser);
  }, []);

  const handleLogout = () => {
    localStorage.removeItem("user");
    setCurrentUser(null);
    window.dispatchEvent(new Event("userLoggedIn")); // Trigger NavBar update
    navigate("/");
  };

  return (
    <>
      <nav
        className={`navbar navbar-expand-lg navbar-dark ${
          isScrolled ? "fixed-top bg-dark shadow" : "bg-dark"
        }`}
      >
        <div className="container">
          <Link to="/" className="navbar-brand">
            <img
              src="../img/icon.png"
              className="img-fluid rounded-circle"
              alt="Logo"
              width="50"
              height="50"
            />
          </Link>

          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navmenu"
          >
            <span className="navbar-toggler-icon"></span>
          </button>

          <div className="collapse navbar-collapse" id="navmenu">
            <ul className="navbar-nav ms-auto">
              {(categories || []).map((category) => (
                <li key={category.id} className="nav-item dropdown">
                  <a
                    className="nav-link dropdown-toggle"
                    href="#!"
                    role="button"
                    data-bs-toggle="dropdown"
                  >
                    {category.title}
                  </a>
                  <ul className="dropdown-menu bg-dark">
                    {(category.trips || []).map((trip) => (
                      <li key={trip.id}>
                        <Link
                          className="dropdown-item text-white"
                          to={`/trips/${trip.path}`}
                        >
                          {trip.title}
                        </Link>
                      </li>
                    ))}
                  </ul>
                </li>
              ))}

              <li className="nav-item d-flex align-items-center ms-lg-3 gap-2">
                {currentUser ? (
                  <>
                    <span className="text-white">
                      👋 {currentUser.name || currentUser.email}
                    </span>
                    <button
                      onClick={() => setShowWishlist(true)}
                      className="btn btn-outline-warning btn-sm"
                    >
                      My Wishlist
                    </button>
                    <button
                      onClick={() => setShowTripHistory(true)}
                      className="btn btn-outline-info btn-sm"
                    >
                      My Bookings
                    </button>

                    <button
                      onClick={handleLogout}
                      className="btn btn-outline-light btn-sm"
                    >
                      Logout
                    </button>
                  </>
                ) : (
                  <>
                    <button
                      onClick={openLoginModal}
                      className="btn btn-outline-light btn-sm"
                    >
                      Login
                    </button>
                    <button
                      onClick={openSignupModal}
                      className="btn btn-light btn-sm text-dark"
                    >
                      Sign Up
                    </button>
                  </>
                )}
              </li>
            </ul>
          </div>
        </div>
      </nav>

      <LoginModal
        show={showLogin}
        handleClose={closeLoginModal}
        openSignupModal={openSignupModal}
        closeLoginModal={closeLoginModal}
      />
      <SignupModal
        show={showSignup}
        handleClose={closeSignupModal}
        openLoginModal={openLoginModal}
        closeSignupModal={closeSignupModal}
      />

      {showWishlist && <WishlistPage onClose={() => setShowWishlist(false)} />}
      {showTripHistory && (
        <TripHistoryOverlay onClose={() => setShowTripHistory(false)} />
      )}
    </>
  );
};

export default NavBar;
